/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../constants/ServiceConstants';

const ModelPropertiesMappingModel = types
  .model('ModelPropertiesMappingModel', {
    data: types.optional(types.array(types.frozen()), []),
    error: types.maybeNull(types.string)
  })
  .actions((self) => ({
    fetchModelProperties() {
      // Tenant-independent list — fetch once per session, retry only when it never loaded.
      if (self.data.length > 0) {
        return;
      }
      Framework.getEventManager().publish(constants.GET_MODEL_PROPERTIES);
    },

    setModelProperties(responseData) {
      applySnapshot(self, {
        ...getSnapshot(self),
        data: responseData || [],
        error: null
      });
    },

    setError(errorMessage) {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: errorMessage
      });
    }
  }));

export default ModelPropertiesMappingModel;
